import { makeStyles, Text } from "@fluentui/react-components";
import * as React from "react";

const useStyles = makeStyles({
  text: {
    fontFamily: "Segoe UI Variable",
    textAlign: "center",
    fontSize: "64px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    marginTop: "0px",
    marginBottom: "32px",

    "@media (max-width:540px)": {
      fontFamily: "Segoe UI",
      fontSize: "1.5rem",
      fontWeight: "600",
      lineHeight: "2rem",
      marginBottom: "16px",
    },
  },

  root: {
    display: "flex",
    alignItems: "stretch",
    flexDirection: "column",
  },
});

export const SectionTitle: React.FC<{ title: string }> = ({ title }) => {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <Text as="h2" className={styles.text}>
        {title}
      </Text>
    </div>
  );
};
